import React, { useState } from 'react';

import AttachIcon from './assets/attach.svg';
import CalendarAddIcon from './assets/calendar-add.svg';
import EmojiIcon from './assets/emoji.svg';
import GifIcon from './assets/gif.svg';
import SendIcon from './assets/send.svg';
import StickerIcon from './assets/sticker.svg';
import TextEditStyleIcon from './assets/text-edit-style.svg';
import * as S from './ComposeBar.styles';


export interface ComposeBarProps {
  onSend: (message: string) => void;
  onAttach?: () => void;
  onEmoji?: () => void;
  onGif?: () => void;
  onSticker?: () => void;
  onSchedule?: () => void;
  onFormat?: () => void;
  placeholder?: string;
}

export const ComposeBar: React.FC<ComposeBarProps> = ({
  onSend,
  onAttach,
  onEmoji,
  onGif,
  onSticker,
  onSchedule,
  onFormat,
  placeholder = 'Type a message',
}) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
      setMessage('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <S.ComposeContainer>
      <S.ComposeContent>
        <S.InputWrapper>
          <S.Input
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
          />
        </S.InputWrapper>
        <S.Footer>
          <S.ActionButtons>
            <S.IconButton onClick={onFormat} aria-label="Format text">
              <S.Icon>
                <TextEditStyleIcon />
              </S.Icon>
            </S.IconButton>
            <S.IconButton onClick={onAttach} aria-label="Attach file">
              <S.Icon>
                <AttachIcon />
              </S.Icon>
            </S.IconButton>
            <S.IconButton onClick={onEmoji} aria-label="Add emoji">
              <S.Icon>
                <EmojiIcon />
              </S.Icon>
            </S.IconButton>
            <S.IconButton onClick={onGif} aria-label="Add GIF">
              <S.Icon>
                <GifIcon />
              </S.Icon>
            </S.IconButton>
            <S.IconButton onClick={onSticker} aria-label="Add sticker">
              <S.Icon>
                <StickerIcon />
              </S.Icon>
            </S.IconButton>
            <S.IconButton onClick={onSchedule} aria-label="Schedule message">
              <S.Icon>
                <CalendarAddIcon />
              </S.Icon>
            </S.IconButton>
          </S.ActionButtons>
          <S.SendButton onClick={handleSend} aria-label="Send message">
            <S.Icon>
              <SendIcon />
            </S.Icon>
          </S.SendButton>
        </S.Footer>
      </S.ComposeContent>
    </S.ComposeContainer>
  );
};

